import { render, staticRenderFns } from "./DiancanJielongHomePage.vue?vue&type=template&id=11c48a54&scoped=true"
import script from "./DiancanJielongHomePage.vue?vue&type=script&lang=js"
export * from "./DiancanJielongHomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c48a54",
  null
  
)

export default component.exports